// extracted by mini-css-extract-plugin
export default {"input":"s8-z","button":"t8-z","selected":"u8-z","unavailable":"v8-z","oos":"w8-z","image":"x8-z","paperCutDisabledOverlay":"y8-z"};